import { batteryProtectUses } from "../battery-protect";
import type { DefLookup } from "../catalog";
import { hasManualCombinerStates } from "../simulate/states";
import type { Issue, System } from "../types";

export function runComponentBehaviorDiagnostics(system: System, lookup: DefLookup): Issue[] {
  const issue = (nodeId: string, code: string, severity: Issue["severity"]): Issue => {
    const node = system.nodes.find(n => n.id === nodeId)!;
    const def = node.kind === "component" ? lookup(node.definitionId, node.customDefinition) : undefined;
    const vars = { label: node.label ?? def?.shortName ?? def?.name ?? nodeId };
    return { code, severity, nodeIds: [nodeId],
      cableIds: system.cables.filter(c => c.fromNodeId === nodeId || c.toNodeId === nodeId).map(c => c.id),
      title: { key: `diag.${code}.title`, vars }, message: { key: `diag.${code}.message`, vars }, fix: { key: `diag.${code}.fix`, vars },
    };
  };
  const issues = batteryProtectUses(system, lookup).map(use => issue(use.nodeId,
    use.reason === "model" ? "battery-protect-model-unverified" : "battery-protect-reverse-use",
    use.reason === "model" ? "warning" : "critical"));
  for (const node of system.nodes) {
    if (node.kind !== "component") continue;
    const def = lookup(node.definitionId, node.customDefinition);
    if (!def || !system.cables.some(c => c.fromNodeId === node.id || c.toNodeId === node.id)) continue;
    if (def.id === "dcdc-redarc-alpha75") issues.push(issue(node.id, "alpha-source-model", "info"));
    if (hasManualCombinerStates(def)) {
      issues.push(issue(node.id, "combiner-manual-state", "info"));
    }
  }
  return issues;
}
